import { useSelector } from "react-redux";

const useCheckPermission = () => {
  const { user } = useSelector((state) => state?.user || {});
  /**
   * Function to check if the user has a specific permission
   * @param {string} module - The module name (e.g., 'orders', 'users').
   * @param {string} action - The action name (e.g., 'view', 'edit', 'delete').
   * @returns {boolean} - True if the user has permission, otherwise false.
   */
  const hasPermission = (module, action) => {
    if (!user) return false;
    // Legacy accounts: company_menu_access was added later. If it's missing
    // entirely, fail open so these users aren't locked out of the sidebar.
    if (!user.company_menu_access) return true;
    return Boolean(user.company_menu_access[module]?.[action]);
  };

  return hasPermission;
};

export default useCheckPermission;
